import React, { useState, useEffect } from "react";
import { Row,Col, Card, CardBody, Button } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import * as url from "../../helpers/url_helper"
import { Config } from "helpers/backend_helper";
import GaugeComponent from 'react-gauge-component'

const Oerview = () => {
  const [data, setData] = useState([])
  const [dates, setDates] = useState([])
  const [staffOnLeave, setStaffOnLeave] = useState([])
  const [amounts, setAmounts] = useState([])
  const [series1, setSeries1] = useState([])

  const [zztotal, setzztotal] = useState(0)
  const [eetotal, seteetotal] = useState(0)
  const [oototal, setoototal] = useState(0)

  const [districtData, setDistrictData] = useState([])

  const [gaugeData, setGaugeData] = useState({})
  const [staffData, setStaffData] = useState({})
  
  const fetchData = async () =>{
    try {
      const r = await axios.get(url.HRDASHGAUGES, Config)
      setGaugeData(r.data)
      const s = await axios.get(url.HRDASHEMPLOYEES, Config)
      setStaffData(s.data)
      let ar = []
      let male = parseFloat(s.data.male)
      let female = parseFloat(s.data.female)
      ar.push(parseFloat(male.toFixed(1))) 
      ar.push(parseFloat(female.toFixed(1))) 
      setSeries1(ar)
      const l = await axios.get(url.HRDASHLEAVE, Config)
      let lr = []; let ln = []
      l.data.map((x)=>{ lr.push(x.month); ln.push(parseInt(x.employees))})
      setDates(lr)
      setStaffOnLeave(ln)
    } catch (e) {
      console.log(e)
    }
  }
  useEffect(()=>{
    fetchData()
  },[])

  const options = {
    chart: {
      toolbar: { show: false}
    },
    dataLabels: { 
      enabled: false,
      style: {
        colors: ["#fff", "#4dff88", "#ffd280"],
        fontSize: '12px',
        fontFamily: 'Helvetica, Arial, sans-serif'
      },
      background: {
        enabled: true,
        borderRadius:10,
        foreColor: '#fff',
        padding: 4,
      }, 
      
    },
    stroke: { 
      curve: "smooth", 
      width: 7 
    },
    markers: { size: 2, style: "hollow" },
    xaxis: {
      categories: dates,
    },
    yaxis: {
      title: {
        text: 'Number of staff',
      },
    },
    title: {
      align: 'center',
    },
    colors: ["#ff8c1a", "#4dff88", "#ffd280"],
  };
  const series =  [
    {
      name: 'Number of staff',
      data: staffOnLeave,
      type: 'line',
      color: '#ff8c1a', 
    }
  ]
  //const series1 = [ze, de, 0];
  const options1 = {
    labels: ["MALES", "FEMALES", "NOT STATED"],
    colors: ["#66b3ff", "#ff99bb", "#ffffff"],
    legend: { show: !1 },
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
        },
      },
    },
  };
  

  return (
    <React.Fragment>
    <Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Staff with full Bio-data</p>
          <GaugeComponent
              value={gaugeData.biodata}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#ff8533','#d9ff66'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Running Contracts</p>
          <GaugeComponent
          
              value={gaugeData.contracts}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#ff8533','#d9ff66'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Updated Job Profile</p>
          <GaugeComponent
          
              value={gaugeData.jobprofile}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#ff8533','#d9ff66'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Staff with Updated Payroll Data</p>
          <GaugeComponent
          
              value={gaugeData.payscale}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#ff8533','#d9ff66'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Staff with Updated Qualifications</p>
          <GaugeComponent
          
              value={gaugeData.education}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#ff8533','#d9ff66'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Staff with Dependants</p>
          <GaugeComponent
          
              value={gaugeData.dependant}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#ff8533','#d9ff66'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Staff with Updated Skills</p>
          <GaugeComponent
          
              value={gaugeData.skills}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#ff8533','#d9ff66'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="3">
        <Card>
          <CardBody>
          <div>
          <p className="text-muted mb-0">Staff with Updated Work Experiences</p>
          <GaugeComponent
          
              value={gaugeData.experience}
              type="radial"
              labels={{
                tickLabels: {
                  type: "outer",
                  ticks: [
                    { value: 20 },
                    { value: 40 },
                    { value: 60 },
                    { value: 80 },
                    { value: 100 }
                  ]
                }
              }}
              arc={{
                colorArray: ['#ff8533','#d9ff66'],
                subArcs: [{limit: 10}, {limit: 30}, {}, {}, {}],
                padding: 0.02,
                width: 0.3
              }}
              pointer={{
                elastic: true,
                animationDelay: 0
              }}
          
           />
          </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="4">
        <Card>
          <CardBody>
          <h4 className="card-title mb-3">Active Staff by Gender</h4>
          <div>
              <div id="donut-chart">
                <ReactApexChart
                  options={options1}
                  series={series1}
                  type="donut"
                  height={440}
                  className="apex-charts"
                />
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col xl="8">
        <Card>
          <CardBody>
            <h4 className="card-title mb-3">Staff Annual leave Trend (last 12 months)</h4>
            <div>
              <div id="overview-chart" className="apex-charts" dir="ltr">
           
                <div id="overview-chart-timeline">
                  <ReactApexChart options={options} series={series} type="line" height={400} />
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
      
      
     
     
      
    </React.Fragment>
  );
};

export default Oerview;
